import { CustomFieldDefinitionTypes } from 'common/store/common/constants';

export enum CustomFieldDataTypeList {
    DOUBLE = 'numberDouble',
    LONG = 'numberLong',
    STRING = 'string',
    DATE = 'date',
    OBJECT = 'object',
}
export type CustomFieldDataType = CustomFieldDataTypeList.DOUBLE | CustomFieldDataTypeList.LONG | CustomFieldDataTypeList.OBJECT
    | CustomFieldDataTypeList.STRING | CustomFieldDataTypeList.DATE;

export type CustomFieldDefinition = {
    allowedValues: any[];
    columnOrderNumber: number;
    dataType: CustomFieldDataType;
    fieldDefinitionId: number;
    fieldName: string;
    selectedByDefault: boolean;
    mutuallyExclusive: boolean;
}
export type CustomField = {
    customFieldDefinitionId: number;
    valueDouble?: number;
    valueLong?: number;
    valueText?: string[];
    valueDate?: string;
    hiddenInContent?: boolean;
}

export interface CustomFieldItem {
    customFieldDefinitionId: number;
    values: Array<string>;
    properties?: {
        hiddenInContent?: boolean;
    };
}

export type CustomFieldsDefinitionKit = {
    value: ValueType;
    initialValue: ValueType;
    isDirty: boolean;
    fieldDefinitionId: number;
    properties?: {
        hiddenInContent?: boolean;
    };
}

export type CustomFieldsDefinitionBase = {
    [CustomFieldDefinitionTypes.SECTION]?: Array<CustomFieldDefinition>;
    [CustomFieldDefinitionTypes.QUESTION]?: Array<CustomFieldDefinition>;
    [CustomFieldDefinitionTypes.QUESTION_SET]?: Array<CustomFieldDefinition>;
    [CustomFieldDefinitionTypes.CONTENT_SOUND]?: Array<CustomFieldDefinition>;
}

export enum CustomFieldInputType {
    NUMERIC_INPUT = 'number',
    TEXT_INPUT = 'text',
    DATE_INPUT = 'date',
    DROPDOWN = 'dropdown',
}

export type ValueType = string | string[] | number | boolean;
